module.exports = __webpack_public_path__ + "static/media/refresh_icon.0d56cbf0.svg";